import { FormGroup, Label, Select } from "@xola/ui-kit";
import React from "react";
import { Purchase } from "types";
import { RefundOption } from "./RefundOption";
import { useRefundOptions } from "./useRefundOptions";

interface RefundOptionsDropdownProps {
    label?: string;
    purchase: Purchase;
    currentOption: RefundOption;
    onChange: (option: RefundOption) => void;
}

export const RefundOptionsDropdown = ({ label, purchase, currentOption, onChange }: RefundOptionsDropdownProps) => {
    const options = useRefundOptions(purchase);

    if (options.length < 2) {
        return null;
    }

    const handleChange = (event: any) => {
        onChange(event.target.value);
    };

    return (
        <FormGroup data-testid="ui-refund-options-dropdown">
            {label && <Label>{label}</Label>}
            <Select value={currentOption} onChange={handleChange}>
                {options.map((option) => {
                    return (
                        <option key={option} value={option}>
                            {option}
                        </option>
                    );
                })}
            </Select>
        </FormGroup>
    );
};
